
<!-- <angular-editor [(ngModel)]="content" [config]="config"></angular-editor> -->

<div class="flex-h flex-end margin-top-m margin-bottom-m">
    <button mat-flat-button color="primary" (click)="onOk()" type="submit">Ok</button>
    <button mat-flat-button color="accent" (click)="onCancel()">Mégsem</button>
</div>
